export default __webpack_public_path__ + "static/TravelLeadersNetwork-e5708649d108a18e1481076a4f75ab8d.svg";